export default __webpack_public_path__ + "static/media/settings.9b5a4343.svg";